import markAttendanceTemplate from "./mark_attendance.html";
import _ from "lodash";
import { SELF_CERTIFIED } from "../../safety.constants";
import mixpanel from "mixpanel-browser";
import en from "./en.translation.json";
import es from "./es.translation.json";
import { safetyMeetingDoneState } from "../../../../app.routes";

class MarkAttendanceController {
    /* @ngInject */
    constructor($state, $q, $timeout, ToastService) {
        this.$state = $state;
        this.$q = $q;

        this.showSignature = false;
        this.$timeout = $timeout;
        this.ToastService = ToastService;
    }

    $onInit() {
        let ctrl = this;
        ctrl.showSignature = _.some(_.map(ctrl.topics, "requires_signature"));
    }

    handleSignatureChange(value) {
        let ctrl = this;
        if (ctrl.signatureTimeout) {
            ctrl.$timeout.cancel(ctrl.signatureTimeout);
        }
    }

    handleSignatureUpdate(value, requests, account) {
        let ctrl = this;
        ctrl.handleSignatureChange(value);
        ctrl.signatureTimeout = ctrl.$timeout(function () {
            ctrl.$timeout.cancel(ctrl.signatureTimeout);
            ctrl.certifyAttendance(requests, account, value);
        }, 2500);
    }

    certifyAttendance(requests, account, signatureImageData) {
        let ctrl = this;
        let requestCompletions = _.map(requests, function (request) {
            return request.complete(
                account,
                SELF_CERTIFIED,
                signatureImageData,
            );
        });
        ctrl.$q.all(requestCompletions).then(
            function (data) {
                mixpanel.track("Subject marked attendance", {
                    company_sid: ctrl.meeting.organizer,
                });
                ctrl.$state.go(safetyMeetingDoneState);
            },
            function () {
                ctrl.ToastService.create(
                    "safety.markAttendance.MARK_COMPLETE_FAILURE_TOAST",
                );
            },
        );
    }
}

export default {
    bindings: {
        meeting: "<",
        requests: "<",
        account: "<",
        topics: "<",
    },
    controller: MarkAttendanceController,
    template: markAttendanceTemplate,
    name: "markAttendance",
    translations: { en, es },
};
